<template>
  <b-overlay :show="formShow" rounded="sm" no-fade class="mt-1">
    <b-card>
      <b-row class="mb-1">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">
                {{ csfId ? "Edit" : "Add" }}
              </th>
            </tr>
          </thead>
        </table>
      </b-row>

      <validation-observer ref="csfRules">
        <b-form>
          <b-row>
            <b-col cols="6" md="12" sm="12">
              <b-form-group label="Title" label-for="title">
                <validation-provider
                  name="title"
                  #default="{ errors }"
                  rules="required"
                >
                  <textarea
                    v-model="csfvalue.title"
                    class="form-control"
                    id="title"
                    name="title"
                    rows="3"
                  ></textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="6" md="12" sm="12">
              <b-form-group label="KPI" label-for="kpi">
                <validation-provider
                  name="kpi"
                  #default="{ errors }"
                  rules="required"
                >
                  <v-select
                    v-model="csfvalue.kpi_id"
                    label="title"
                    :reduce="(val) => val.id"
                    :options="kpis"
                    :clearable="true"
                  ></v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col cols="12">
              <b-button
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="float-right"
              >
                {{ csfId ? "Update" : "Create" }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>

<script>
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import vSelect from "vue-select";
import router from "@/router";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";

export default {
  components: {
    vSelect,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },

  setup() {
    const CSF_CODE_APP_STORE_MODULE_NAME = "settings";

    if (!store.hasModule(CSF_CODE_APP_STORE_MODULE_NAME)) {
      store.registerModule(CSF_CODE_APP_STORE_MODULE_NAME, settingsStoreModule);
    }

    onUnmounted(() => {
      if (store.hasModule(CSF_CODE_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(CSF_CODE_APP_STORE_MODULE_NAME);
      }
    });
  },

  data() {
    return {
      csfvalue: {
        title: "",
        kpi_id: "",
      },
      kpis: [],
      formShow: false,
      csfId: null,
    };
  },

  mounted() {
    this.initializeForm();
  },

  methods: {
    async initializeForm() {
      try {
        await this.getkpis();

        if (router.currentRoute.params.id) {
          this.csfId = parseInt(router.currentRoute.params.id);
          await this.getCSFById();
        }
      } catch (error) {
        this.handleError("Failed to initialize form.");
      }
    },

    getkpis() {
      return store.dispatch("settings/getAllKPIs").then((res) => {
        this.kpis = res.data;
      });
    },

    getCSFById() {
      return store
        .dispatch("settings/getCSFById", { id: this.csfId })
        .then((res) => {
          this.csfvalue = res.data;
        });
    },

    formSubmitted() {
      this.formShow = true;

      this.$refs.csfRules.validate().then((success) => {
        if (success) {
          const CSF = this.csfId ? "settings/updateCSF" : "settings/saveCSF";

          store
            .dispatch(CSF, this.csfvalue)
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Successful",
                  text: this.csfId
                    ? "✔️ Critical success factor Updated Successfully"
                    : "✔️ Critical success factor Added Successfully",
                  icon: "ThumbsUpIcon",
                  variant: "success",
                },
              });

              router.push({ name: "settings-csfs" });
            })
            .catch(() => {
              this.handleError(
                "An error occurred while saving the critical success factors."
              );
            })
            .finally(() => {
              this.formShow = false;
            });
        } else {
          this.formShow = false;
        }
      });
    },

    handleError(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: message,
          icon: "AlertCircleIcon",
          variant: "danger",
        },
      });
      this.formShow = false;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
